// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"79f1bf91","37":"9f2a8cd9","122":"cce432ae","308":"de3f30fc","324":"aa39710b","351":"9132c63f","366":"884cfb60","369":"2cb0c48e","382":"6b9bc9cd","720":"3880cdd6","849":"f19544cf","851":"9391fd9e","937":"88a940cb","945":"454c9935","973":"a8f172e6"}[chunkId] + ".chunk.js";
};